export default "__VITE_ASSET__DCgHi6dp__"